import React, { useEffect } from 'react';
import { Redirect, useHistory, useLocation } from 'react-router-dom';
import EveRoutes from '../EveRoutes';

export interface EveRedirectProps {
  pageNotFoundPath?: string;
}

const OriginRedirect = ({ path }: { path: string }): JSX.Element => {
  const history = useHistory();
  const location = useLocation();

  const { REDIRECT_LOADING } = EveRoutes;

  // This briefly replaces the current history entry in memory with /redirect so that
  // the subsequent redirect from window.location.replace is treated as a new page request
  useEffect(() => {
    if (path === REDIRECT_LOADING) {
      const destination = new URLSearchParams(location.search).get('to') as string;
      window.location.replace(destination);
    } else {
      history.replace({
        pathname: REDIRECT_LOADING,
        search: `?to=${path}`,
      });
    }
  }, [path, history, location, REDIRECT_LOADING]);

  return <>Loading...</>;
};

const EveRedirect = (props: EveRedirectProps): JSX.Element | null => {
  const { pageNotFoundPath } = props;

  const location = useLocation();

  const requestedPath = location.pathname;
  const eveRoutes = Object.values(EveRoutes) as string[];

  if (eveRoutes.includes(requestedPath)) {
    return <OriginRedirect path={requestedPath} />;
  }

  if (pageNotFoundPath) {
    return <Redirect to={pageNotFoundPath} />;
  }

  return null;
};

export default EveRedirect;
